import { TIPO_DOCUMENTAL } from './inventories';
import { UnidadSolicitud } from './unidad-solicitud';
import { SolicitudMateriales } from './solicitud-materiales';

export class Solicitud {
    id: number;
    idTipoServicio: number;
    idCreador: number;
    idSolicitante: number;
    idSerie: number;
    idSerieDevolucionSinPrestamo: number;
    idCliente: number;
    idEstadoServicio: number;
    idDireccion: number;
    idUsuarioAprobacion: number;
    fechaCreacion: string;
    fechaSolicitud: string;
    fechaFinalizacion: string;
    fechaSLA: string;
    email: string;
    normalUrgente: string;
    manualMasiva: string;
    codServicioCliente: string;
    ceco: string;
    formatoPrestamo: string;
    idUsuarioPeticion: number;
    estadoGenServicio: number;
    hasFiles: boolean;
    idtipomotivo: number;
    motivotext: string;
    otromotivo: string;

    contenidosInventario: ContenidoInventariado[];
    contenidosNoInvetariados: ContenidoNoInventariado[];
    contenidosMateriales: SolicitudMateriales[];

    unidades: UnidadSolicitud[] = [];

    constructor() { }

    static toModel(json: string): Solicitud {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new Solicitud();
        toReturn.id = data.Id;
        toReturn.idTipoServicio = data.ID_TIPO_SERVICIO;
        toReturn.idCreador = data.ID_CREADOR;
        toReturn.idSolicitante = data.ID_SOLICITANTE;
        toReturn.idSerie = data.ID_SERIE;
        toReturn.idCliente = data.ID_CLIENTE;
        toReturn.idEstadoServicio = data.ID_ESTADO_SERVICIO;
        toReturn.idDireccion = data.ID_DIRECCION;
        toReturn.idUsuarioAprobacion = data.ID_USUARIO_APROBACION;
        toReturn.fechaCreacion = data.FECHA_CREACION;
        toReturn.fechaSolicitud = data.FECHA_SOLICITUD;
        toReturn.fechaFinalizacion = data.FECHA_FINALIZACION;
        toReturn.fechaSLA = data.FECHA_SLA;
        toReturn.email = data.EMAIL;
        toReturn.normalUrgente = data.NORMAL_URGENTE;
        toReturn.manualMasiva = data.MANUAL_MASIVA;
        toReturn.codServicioCliente = data.COD_SERVICIO_CLIENTE;
        toReturn.ceco = data.CECO;
        toReturn.formatoPrestamo = data.FORMATO_PRESTAMO;
        toReturn.idUsuarioPeticion = data.ID_USUARIO_PETICION;
        toReturn.estadoGenServicio = data.ESTADO_GEN_SERVICIO;
        toReturn.contenidosInventario = data.CONTENIDOS_INVENTARIO.map(contenido => ContenidoInventariado.toModel(JSON.stringify(contenido)));
        toReturn.contenidosNoInvetariados = data.CONTENIDOS_SIN_INVENTARIO.map(contenido => ContenidoNoInventariado.toModel(JSON.stringify(contenido)));
      toReturn.contenidosMateriales = data.CONTENIDOS_MATERIALES;
      toReturn.motivotext = data.MOTIVOTEXT;
      toReturn.otromotivo = data.MOTIVO;
        return toReturn;
    }

    toView(): any {
        const obj = {};
        obj['Id'] = this.id;
        obj['ID_TIPO_SERVICIO'] = this.idTipoServicio;
        obj['ID_CREADOR'] = this.idCreador;
        obj['ID_SOLICITANTE'] = this.idSolicitante;
        obj['ID_SERIE'] = this.idSerie;
        obj['ID_CLIENTE'] = this.idCliente;
        obj['ID_ESTADO_SERVICIO'] = this.idEstadoServicio;
        obj['ID_DIRECCION'] = this.idDireccion;
        obj['ID_USUARIO_APROBACION'] = this.idUsuarioAprobacion;
        obj['FECHA_CREACION'] = this.fechaCreacion;
        obj['FECHA_SOLICITUD'] = this.fechaSolicitud;
        obj['FECHA_FINALIZACION'] = this.fechaFinalizacion;
        obj['FECHA_SLA'] = this.fechaSLA;
        obj['EMAIL'] = this.email;
        obj['NORMAL_URGENTE'] = this.normalUrgente;
        obj['MANUAL_MASIVA'] = this.manualMasiva;
        obj['COD_SERVICIO_CLIENTE'] = this.codServicioCliente;
        obj['CECO'] = this.ceco;
        obj['FORMATO_PRESTAMO'] = this.formatoPrestamo;
        obj['ID_USUARIO_PETICION'] = this.idUsuarioPeticion;
        obj['ESTADO_GEN_SERVICIO'] = this.estadoGenServicio;
        obj['HAS_FILES'] = this.hasFiles;
        obj['CONTENIDOS_INVENTARIO'] = this.contenidosInventario ? this.contenidosInventario.map(contenido => contenido.toView())
                                                                    : null;
        obj['CONTENIDOS_SIN_INVENTARIO'] = this.contenidosNoInvetariados ? this.contenidosNoInvetariados.map(contenido => contenido.toView())
                                                                    : null;
      obj['CONTENIDOS_MATERIALES'] = this.contenidosMateriales;
      obj['ID_MOTIVO'] = this.idtipomotivo;
      obj['MOTIVO'] = this.otromotivo;

        return obj;
    }
}

export class ContenidoInventariado {

    observacionParcial: string;
    idContenido: number;
    idInventario: string;
    tipoUnidadDocumental: TIPO_DOCUMENTAL;

    constructor() { }

    static toModel(json: string): ContenidoInventariado {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new ContenidoInventariado();
        toReturn.observacionParcial = data.OBS_PARCIAL;
        toReturn.idContenido = data.ID_CONTENIDO;
        toReturn.idInventario = data.ID_INVENTARIO;
        toReturn.tipoUnidadDocumental = data.TIPO_UNIDAD_DOCUMENTAL;
        return toReturn;
    }

    toView(): any {
        const obj = {};
        obj['OBS_PARCIAL'] = this.observacionParcial;
        obj['ID_CONTENIDO'] = this.idContenido;
        obj['ID_INVENTARIO'] = this.idInventario;
        obj['TIPO_UNIDAD_DOCUMENTAL'] = this.tipoUnidadDocumental as number;
        return obj;
     }
}

export class ContenidoNoInventariado {
    campos: CampoValor[];

    constructor() { }

    static toModel(json: string): ContenidoNoInventariado {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new ContenidoNoInventariado();
        toReturn.campos = data.Campos.map(campo => CampoValor.toModel(JSON.stringify(campo)));
        return toReturn;
    }

    toView(): any {
        const obj = {};
        obj['Campos'] = this.campos.map(campo => campo.toView());
        return obj;
    }
}

export class CampoValor {

    nombreCampo: string;
    valor: string;
    id: number;

    constructor() { }

    static toModel(json: string): CampoValor {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new CampoValor();
        toReturn.id = data.ID;
        toReturn.nombreCampo = data.NOMBRE_CAMPO;
        toReturn.valor = data.VALOR;
        return toReturn;
    }

    toView(): any {
        const obj = {};
        obj['NOMBRE_CAMPO'] = this.nombreCampo;
        obj['VALOR'] = this.valor;
        obj['ID'] = this.id;
        return obj;
    }
 }


